{
    "local": {
      "uiUrl": "http://localhost:4700/",
      "apiAuthUrl": "http://localhost:4700/*",
      "apiUrl": "http://localhost:4700",
      "sfsAPIUrl": "http://localhost:4700",
      "sfsAuthUrl": "http://localhost:4700",
      "auth": {
        "domain": "auth.lincolnfinancial-dev.lfg.com",
        "clientId": "cW1aXNOfewp1eObLNkkIybhqKMMdJZny",
        "audience": "https://lincolnfinancial-dev.lfg.com/api",
        "useRefreshTokens": true
      }
    },
    "dev": {
      "uiUrl": "https://annuity-pending-dev-v1.web.lfg.com/",
      "apiAuthUrl": "https://api.annuity-pending-dev.web.lfg.com/annuities-pending*",
      "apiUrl": "https://api.annuity-pending-dev.web.lfg.com/annuities-pending",
      "sfsAuthUrl": "https://api.sfs-dev.web.lfg.com/secure-fileservice-app/SecureFileSubmission*",
      "sfsAPIUrl": "https://api.sfs-dev.web.lfg.com/secure-fileservice-app/SecureFileSubmission",
      "auth": {
        "domain": "auth.lincolnfinancial-test.lfg.com",
        "clientId": "lWj2XEq9IvtpshSU2obutBJo0IE5lfeM",
        "audience": "https://lincolnfinancial-test.lfg.com/api",
        "useRefreshTokens": true
      }
    },
    "test": {
      "uiUrl": "https://annuities-pendingv2-test.web.lfg.com/",
      "apiAuthUrl": "https://api2.annuity-pending-test.web.lfg.com/annuities-pending*",
      "apiUrl": "https://api2.annuity-pending-test.web.lfg.com/annuities-pending",
      "sfsAuthUrl": "https://api.sfs-test.web.lfg.com/secure-fileservice-app/SecureFileSubmission*",
      "sfsAPIUrl": "https://api.sfs-test.web.lfg.com/secure-fileservice-app/SecureFileSubmission",
      "auth": {
        "domain": "auth.lincolnfinancial-uat.lfg.com",
        "clientId": "reOlq42OVcxoCf7wwfPP0cTBNrn0zLiX",
        "audience": "https://lincolnfinancial-uat.lfg.com/api",
        "useRefreshTokens": true
      }
    },
    "preprod": {
      "uiUrl": "https://annuity-pending-dev.web.lfg.com/",
      "apiAuthUrl": "https://api.annuity-pending-test.web.lfg.com/annuities-pending*",
      "apiUrl": "https://api.annuity-pending-test.web.lfg.com/annuities-pending",
      "sfsAuthUrl": "https://api.sfs-test.web.lfg.com/secure-fileservice-app/SecureFileSubmission*",
      "sfsAPIUrl": "https://api.sfs-test.web.lfg.com/secure-fileservice-app/SecureFileSubmission",
      "auth": {
        "domain": "auth.lincolnfinancial-preprod.lfg.com",
        "clientId": "76gScGu6eZX7k5JiZMocT1AtvDbiNNRb",
        "audience": "https://lincolnfinancial-preprod.lfg.com/api",
        "useRefreshTokens": true
      }
    },
    "prod": {
      "uiUrl": "https://annpend.web.lfg.com/",
      "apiAuthUrl": "https://api.annpend.web.lfg.com/annuities-pending*",
      "apiUrl": "https://api.annpend.web.lfg.com/annuities-pending",
      "sfsAuthUrl": "https://api.sfs.web.lfg.com/secure-fileservice-app/SecureFileSubmission*",
      "sfsAPIUrl": "https://api.sfs.web.lfg.com/secure-fileservice-app/SecureFileSubmission",
      "auth": {
        "domain": "auth.lincolnfinancial.com",
        "clientId": "c8nGIT1MQfS6kabf4qBQ2eg7cXDIkPvl",
        "audience": "https://www.lincolnfinancial.com/api",
        "useRefreshTokens": true
      }
    }
  }
